import {
	API_ADMIN_GET_ALL_LAB_PARAM_GROUP,
	API_ADMIN_GET_LAB_PARAM_GROUP,
	ADMIN_INIT_NEW_LAB_PARAM_GROUP,
	ADMIN_RESET_FOCUS_LAB_PARAM_GROUP,
	API_ADMIN_POST_LAB_PARAM_GROUP,
	API_ADMIN_PATCH_LAB_PARAM_GROUP,
	API_ADMIN_DELETE_LAB_PARAM_GROUP,
} from 'actions/labParamGroup';


export function adminGetAllLabParamGroups() {
	return {
		type: API_ADMIN_GET_ALL_LAB_PARAM_GROUP,
		payload: {
			request: {
				url: `/admin/labParamGroups`
			}
		}
	};
}

export function adminGetLabParamGroup(labParamGroup) {
	return {
		type: API_ADMIN_GET_LAB_PARAM_GROUP,
		payload: {
			request: {
				url: `/admin/labParamGroups/${labParamGroup.id}`
			}
		}
	};
}

export function adminPostLabParamGroup(labParamGroup) {
	return {
		type: API_ADMIN_POST_LAB_PARAM_GROUP,
		payload: {
			request: {
				url: `/admin/labParamGroups`,
				method: 'POST',
				data: labParamGroup
			}
		}
	};
}

export function adminPatchLabParamGroup(labParamGroup) {
	return {
		type: API_ADMIN_PATCH_LAB_PARAM_GROUP,
		payload: {
			request: {
				url: `/admin/labParamGroups/${labParamGroup.id}`,
				method: 'PATCH',
				data: labParamGroup
			}
		}
	};
}

export function adminDeleteLabParamGroup(labParamGroup) {
	return {
		type: API_ADMIN_DELETE_LAB_PARAM_GROUP,
		payload: {
			request: {
				url: `/admin/labParamGroups/${labParamGroup.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewLabParamGroup() {
	return {
		type: ADMIN_INIT_NEW_LAB_PARAM_GROUP
	};
}

export function resetFocusLabParamGroup() {
	return {
		type: ADMIN_RESET_FOCUS_LAB_PARAM_GROUP
	};
}
